import styled from "styled-components";

const SidebarStyleWrapper = styled.div`
  background: #0e161c;
  padding: 30px 30px 40px;

  .widget_title {
    h2 {
      margin: 0 0 15px;
    }
  }

  .tags_wrapper {
    margin-top: 40px;
    .widget_title {
      h2 {
        margin: 0 0 25px;
      }
    }
  }
`;

export default SidebarStyleWrapper;
